import styled from "styled-components";

export const PhotoContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center:
`;

export const PhotoField = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    img {
        height: 600px;
        width: 600px;
        border-radius: 10px;
    }
`;

export const PhotoButtons = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
`;

export const PhotoButton = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;
